import { ConnectedPageLayout } from 'components/layout/page-layout';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box, LinearProgress } from '@mui/material';

import { useGetCompaniesScreenDataQuery } from '@libs/graphql-types';
import Typography from '@libs/ui/components/typography';

import { useCommunityFilter } from './hooks';
import { CompaniesList } from './list';
import { CompaniesFilter } from './list/CompaniesFilter';

export const CompaniesScreen = () => {
  const { t } = useTranslation('talent');
  const filter = useCommunityFilter();
  const { loading, data, refetch } = useGetCompaniesScreenDataQuery({
    variables: {
      pooling_type: filter.type,
      country: filter.country ? filter.country : undefined,
      first: 50,
    },
  });

  return (
    <ConnectedPageLayout
      documentTitle={t('companies.documentTitle')}
      headerProps={{ accountProps: {} }}
      drawerProps={{}}
    >
      <Box>
        <Typography variant="h5" paragraph>
          {t('companies.title')}
        </Typography>
        <Typography variant="body1">{t('companies.subtitle')}</Typography>

        <Box mt={6}>
          <CompaniesFilter filter={filter} />
        </Box>

        <Box mt={6}>
          {loading && (
            <Box mb={6}>
              <LinearProgress color="info" />
            </Box>
          )}
          <CompaniesList refetch={refetch} companies={data?.poolingCompanies} />
        </Box>

        {/* <Box> */}
        {/*   <Invite /> */}
        {/* </Box> */}
      </Box>
    </ConnectedPageLayout>
  );
};
